import { type PropsWithChildren } from "react";
import BaseTab, { type TabProps as BaseTabProps } from "../shared/tabstrip/tab";

interface TabProps extends PropsWithChildren<BaseTabProps> {
  
}

const Tab: React.FC<TabProps> = ({ ...props }) => {
  return <BaseTab {...props} />;
};

export default Tab;
